<div class="my-overlay" *ngIf="getOnSearchDownload()">
  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
</div>
<div class="grid p-fluid" style="margin: 0 10px;">
<h2>Documentos de Facturación</h2>
</div>

<p-message [text]="msg[0]?.detail || msg[0]?.summary || ''" *ngIf="DateValid"></p-message>
<form [formGroup]="documentSearchCriteria" (ngSubmit)="onSubmit(documentSearchCriteria.value)">
  <p>Criterio de Búsqueda:</p>

  <div class="search-grid">

    <!-- Fila 1: 5 columnas -->
    <div class="search-field" (keydown.enter)="onSubmit(documentSearchCriteria.value)">
      <label for="typeDoc">Tipo de documento:</label>
      <input type="text" pInputText pKeyFilter="alpha" id="typeDoc" formControlName="documentType"
             maxlength="4" style="text-transform: uppercase"
             pTooltip="FC = Factura | NC = Nota de crédito | ND = Nota de débito" tooltipEvent="focus">
    </div>

    <div class="search-field" (keydown.enter)="onSubmit(documentSearchCriteria.value)">
      <label for="letterDoc">Letra del documento:</label>
      <input type="text" pInputText pKeyFilter="alpha" id="letterDoc" formControlName="documentLetter"
             maxlength="1" style="text-transform: uppercase"
             pTooltip="Ingresá la letra del comprobante: A, B o C" tooltipEvent="focus">
    </div>

    <div class="search-field" (keydown.enter)="onSubmit(documentSearchCriteria.value)">
      <label for="salePoint">Punto de venta:</label>
      <input type="text" pInputText pKeyFilter="int" id="salePoint" formControlName="documentSalesPoint"
             maxlength="17" style="text-transform: uppercase"
             pTooltip="Ingresá el número de punto de venta" tooltipEvent="focus">
    </div>

    <div class="search-field" (keydown.enter)="onSubmit(documentSearchCriteria.value)">
      <label for="docNumber">Nro del documento:</label>
      <input type="text" pInputText pKeyFilter="int" id="docNumber" formControlName="documentNumber"
             maxlength="10" style="text-transform: uppercase"
             pTooltip="Ingresá el número del comprobante" tooltipEvent="focus">
    </div>

    <div class="search-field" (keydown.enter)="onSubmit(documentSearchCriteria.value)">
      <label for="cuitNumber">Nro de CUIT:</label>
      <input type="text" pInputText pKeyFilter="int" id="cuitNumber" formControlName="cuitNumber"
             maxlength="13" style="text-transform: uppercase"
             pTooltip="Ingresá el CUIT sin guiones (ej: 20123456789)" tooltipEvent="focus">
    </div>

    <!-- Fila 2: 4 columnas + 1 vacío -->
    <div class="search-field">
      <label for="fromDate">Desde:</label>
      <span pTooltip="Fecha de emisión desde" tooltipEvent="hover">
        <p-datepicker id="fromDate" formControlName="documentDateFrom" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </span>
    </div>

    <div class="search-field">
      <label for="toDate">Hasta:</label>
      <span pTooltip="Fecha de emisión hasta" tooltipEvent="hover">
        <p-datepicker id="toDate" formControlName="documentDateTo" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </span>
    </div>

    <div class="search-field" (keydown.enter)="onSubmit(documentSearchCriteria.value)">
      <label for="nroVin">Nro de Vin</label>
      <span pTooltip="Podés buscar por 17 dígitos: VIN completo. O por 8 dígitos: número de serie." tooltipEvent="hover">
        <p-autoComplete [(ngModel)]="vinSelected" [suggestions]="vins" (completeMethod)="getVINSforVehicle(vinSelected!)"
                        type="text" id="nroVin" formControlName="documentVinNumber">
        </p-autoComplete>
      </span>
    </div>

    <div class="search-field">
      <label for="origen">Origen:</label>
      <span pTooltip="Filtrá por origen del documento: ARG o PER" tooltipEvent="hover">
        <p-select id="origen" [options]="optionsOrigin" name="seleccionar" formControlName="documentOrigin"></p-select>
      </span>
    </div>

    <!-- columna vacía para mantener alineación -->
    <div class="search-field"></div>

  </div>

  <div class="button-container">
    <div class="button-container1">
      <button pButton type="submit" label="Buscar Documento" class="p-button-rounded"
              pTooltip="No olvides utilizar algún filtro para tu búsqueda"></button>
      <button pButton type="button" (click)="resetFormGroup()" label="Limpiar campos"
              class="p-button-rounded p-button-secondary"
              pTooltip="Se limpiarán todos los filtros"></button>
    </div>
    <div class="button-container2">
      <button pButton type="button" (click)="downloadZipPdf()" label="Descargar seleccion"
              class="p-button-rounded"
              pTooltip="Se descargarán todos los pdf seleccionados."></button>
      <button pButton type="button" (click)="downloadDocumentosPagina()" label="Descargar pagina"
              class="p-button-rounded"
              pTooltip="Se descargarán todos los documentos de la página."></button>
      <button *ngIf="isIntern" pButton type="button" (click)="massiveDownload()" label="Descargar todos"
              class="p-button-rounded"
              pTooltip="Se descargarán todos los documentos hallados sin importar la página."></button>
    </div>
  </div>

</form>
<div>
  <p-progressBar *ngIf="getOnSearch()" mode="indeterminate"></p-progressBar>

  <p-table #documentsTable [columns]="colums" [value]="documentList" [paginator]="true"
           [rows]="15" [lazy]="true" (onLazyLoad)="loadData($event)"
           [totalRecords]="totalOfDocs" id="documentsTable">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of colums">
          {{col.header}}
        </th>
        <th>
          <input type="checkbox" id="globalChek" (click)="selectedAllDocuments()"
                 class="ford-global-check">
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-document let-colums="colums">
      <tr>
        <td style="text-align: center;">{{ getTypeOfDoc(document) }}</td>
        <td style="text-align: center;">{{ document.vvh460Dicsub02D208 }}</td>
        <td style="text-align: center;">{{ document.vvh460DocLetra }}</td>
        <td style="text-align: center;">{{ document.vvh460DocPvta }}</td>
        <td style="text-align: center;">{{ document.vvh460DocNroco }}</td>
        <td style="text-align: center;">{{ document.vvh460FemisDoc | date: 'dd/MM/yyyy' }}</td>
        <td style="text-align: center;">{{ document.vvh002NroVin }}</td>
        <td style="text-align: center;">{{ document.vvh402Cuit }}</td>
        <td style="text-align: center;">
          <div class="pdf-actions">
            <button pButton type="button" label="Descargar" class="p-button-rounded"
                    (click)="downloadPdf(document)" id="download"></button>
            <button pButton type="button" label="Abrir" class="p-button-rounded p-button-secondary"
                    (click)="showPdf(document)" id="open"></button>
          </div>
        </td>
        <td style="text-align: center;">
          <p-checkbox name="pdf" [value]="document" [(ngModel)]="selectedDocuments" class="ford-checkbox"></p-checkbox>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
